import { render, staticRenderFns } from "./Naw.vue?vue&type=template&id=9850ff64&"
import script from "./Naw.vue?vue&type=script&lang=js&"
export * from "./Naw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports